"use client";

import { Text, Field } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import React from "react";
import * as Container from "@repo/ui/container";
import { TYPOGRAPHY_HEADING1 } from "@/typography-constants";
import { isMobile } from "../../../utils";
import styles from "./topic-header.module.css";

type TopicHeaderProps = {
  heading: Field<string>;
  className?: string;
  tag: string;
  isInverted?: boolean;
};

const TopicHeader = ({
  heading,
  className = "topicHeader",
  tag,
  isInverted,
}: TopicHeaderProps): JSX.Element => {
  const mobileView = isMobile();

  return (
    <Container.Root size="large" gutter={mobileView ? "lg" : "2xl"} asChild>
      <div
        className={clsx(
          styles.headerContainer,
          styles[className],
          isInverted && styles.inverted,
        )}
      >
        <Text field={heading} tag={tag} className={TYPOGRAPHY_HEADING1} />
      </div>
    </Container.Root>
  );
};

export default TopicHeader;
